import $ from 'jquery';
import 'block-ui';

var pageLeaveEvents = {};

export function trimWhiteSpace(x) {
    return x.replace(/^\s+|\s+$/gm,'');
}   

export function bConsole() {
    //TODO get global debug variable
    //if (debug) {

        var args = [];
        for (var i = 0; i < arguments.length; ++i) args[i] = arguments[i];

        if (typeof console !== "undefined") { 

                for (var j = 0; j < args.length; ++j) {
                        console.log(args[j]);
                }

        } else {

                for (var k = 0; k < args.length; ++k) {
                        alert(args[k]);
                }  
        }   
    //}
}
export function isSessionStorageAvailable() {
    
    try {
    
        sessionStorage.setItem("merTest", "1");
        sessionStorage.removeItem("merTest");
        return true;
      
    } catch (error) {
        
        return false;
      
    } 
}

function clearState() {

    if (isSessionStorageAvailable()) {

      sessionStorage.clear();

    }
}

export function toType(obj) {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}

export function isFormData(obj){
    return toType(obj) == "formdata";
}

export function isWindow( obj ){
    return $.isWindow( obj );
}

export function formDataAvailable(){
    return (typeof window.FormData !== "undefined" && window.FormData);
}

export function  removeNullInput(input){
    if (typeof input === "undefined" || input === null){
        return "";
    }

    var str = input.toString();
    
    if (str === "undefined" || str === "null"){
        return "";
    }
    return input;
}

export function  nullEmptyInput(input){
    if (typeof input === "undefined" || input.trim() === ""){
        return null;
    }

    return input;
}


export function escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
export function removeEscapeChars(text) {
    return text.replace(/(?:\\(.))/g, '$1');
}

export function addPageLeaveWarning( pageIdentifier, warningMessage,  ){
    
    clearPageLeaveWarning( pageIdentifier );
    
    var unloadWarningFunction = function( event ){
        event.preventDefault();
        return warningMessage;
    }
    
    $(window).on( 'beforeunload', unloadWarningFunction );
    
    pageLeaveEvents[ pageIdentifier ] = unloadWarningFunction;

}

export function clearPageLeaveWarning( pageIdentifier ){
    if ( typeof pageLeaveEvents[ pageIdentifier ] !== "undefined" ){
        $( window ).off( 'beforeunload', pageLeaveEvents[ pageIdentifier ] );
        delete pageLeaveEvents[ pageIdentifier ];
    }
}

export function triggerCustomEvent(element, eventName, eventData = null){
    var result = $(element).triggerHandler( eventName, eventData );
        
    if ( result === false ){
        return false;
    }
    return true;
}
